/**
 * reducers/locales.ts
 * desc: application locale
 * note: implementation is based on the formatjs lib
 */

import { updateIntlProvider, type CompiledMessages } from '../../utilities/localization';
import type { Reducer } from '@reduxjs/toolkit';
import type { LocalesAction, UpdateLocaleErrorPayload, UpdateLocaleSuccessPayload } from '../actions/locales';

export interface LocalesState {
    isLoading: {
        updateLocale: boolean;
    };
    locale: string;
    messages: CompiledMessages;
}

const INITIAL_STATE: LocalesState = {
    isLoading: {
        updateLocale: false,
    },
    locale: '',
    messages: {},
};


const localeReducer = (state: LocalesState = INITIAL_STATE, action: LocalesAction): LocalesState => {
    switch (action.type) {
        // UPDATE locale (Instance)
        case 'UPDATE_LOCALE_ERROR':
            return _updateLocaleError(state, action.payload);
        case 'UPDATE_LOCALE_REQUEST':
            return _updateLocaleRequest(state);
        case 'UPDATE_LOCALE_SUCCESS':
            return _updateLocaleSuccess(state, action.payload);

        default:
            return state;
    }
};



//*************************************************
//*****   UPDATE Locale (Instance)   **************
//*************************************************
function _updateLocaleRequest(state: LocalesState): LocalesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateLocale: true,
        },
    };
}

function _updateLocaleSuccess(state: LocalesState, payload: UpdateLocaleSuccessPayload): LocalesState {
    updateIntlProvider(payload.locale, payload.dictionaries);

    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateLocale: false,
        },
        locale: payload.locale,
        messages: payload.dictionaries,
    };
}

function _updateLocaleError(state: LocalesState, payload: UpdateLocaleErrorPayload): LocalesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateLocale: false,
        },
        locale: payload.locale,
        messages: payload.messages,
    };
}


export default localeReducer as Reducer<LocalesState>;
